export const CLOSE = 'baq/sideNav/bulkEditEstimatorModal/CLOSE';
export const OPEN = 'baq/sideNav/bulkEditEstimatorModal/OPEN';
